import { Routes } from '@angular/router';

export const clubMembersRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./club-members.page').then((m) => m.ClubMembersPage),
  },
];
